import { render, staticRenderFns } from "./JudgeStory.vue?vue&type=template&id=52794b2f&scoped=true"
import script from "./JudgeStory.vue?vue&type=script&lang=js"
export * from "./JudgeStory.vue?vue&type=script&lang=js"
import style0 from "./JudgeStory.vue?vue&type=style&index=0&id=52794b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52794b2f",
  null
  
)

export default component.exports